module.exports = __webpack_public_path__ + "static/media/to-do-list.31ac4dc3.svg";